import { defineStore } from 'pinia'
// import { getAnalytics, setUserId } from 'firebase/analytics'

// const analytics = getAnalytics()

export const useAuthStore = defineStore({
  id: 'login',
  state: () => ({
    sandsTalkToken: '',
    username: '',
    password: '',
    authToken: '',
    userMobile: '',
    userId: '',
    wxworkCode: '',
    wxworkType: '',
    appId: '',
    jumpName: '',
    wxworkJumpType: '',
    wxworkJumpModuleId: '',
    customTemplateId: '',
    teamStudy: 0,
    userAuth: {
      teamLearningLabel: 0,
      teachingMgtLabel: 0, // 教学管理标签: 0-无权限 1-有权限
      workbenchLabel: 0 // 管理员工作台入口：0：不展示，1：展示
    },
    teachingMgtLabel: 0, // 教学管理标签: 0-无权限 1-有权限
    showCompany: false, // 是否显示公司下拉或内容
    deptId: '', // 部门ID
    hasHistoryData: false, // 是否有历史数据
    wearImageId: '', // 勋章ID
    wearImageUrl: '', // 勋章图片URL
    roleCodes: [] as string[] // 角色编码列表
  }),
  actions: {
    setAccessToken(token: string) {
      this.sandsTalkToken = token
    },
    setUsername(username: string) {
      this.username = username
    },
    setPassword(password: string) {
      this.password = password
    },
    setAuthToken(authToken: string) {
      this.authToken = authToken
    },
    setUserMobile(userMobile: string) {
      this.userMobile = userMobile
    },
    setUserId(userId: string) {
      // setUserId(analytics, userId)
      this.userId = userId
    },
    setBusinessWechatCode(wxworkCode: string) {
      this.wxworkCode = wxworkCode
    },
    setBusinessWechatType(wxworkType: string) {
      this.wxworkType = wxworkType
    },
    setAppId(appId: string) {
      this.appId = appId
    },
    setJumpName(jumpName: string) {
      this.jumpName = jumpName
    },
    setJumpType(wxworkJumpType: string) {
      this.wxworkJumpType = wxworkJumpType
    },
    setJumpModuleId(wxworkJumpModuleId: string) {
      this.wxworkJumpModuleId = wxworkJumpModuleId
    },
    setCustomTemplateId(customTemplateId: string) {
      this.customTemplateId = customTemplateId
    },
    setTeamStudy(teamStudy: number) {
      this.teamStudy = teamStudy
    },
    setUserAuth(userAuth: { teamLearningLabel: number; teachingMgtLabel: number; workbenchLabel: number }) {
      this.userAuth = userAuth
    },
    setTeachingMgtLabel(teachingMgtLabel: number) {
      this.teachingMgtLabel = teachingMgtLabel
    },
    setShowCompany(showCompany: boolean) {
      this.showCompany = showCompany
    },
    setDeptId(deptId: string) {
      this.deptId = deptId
    },
    setHasHistoryData(hasHistoryData: boolean) {
      this.hasHistoryData = hasHistoryData
    },
    setWearImageId(wearImageId: string) {
      this.wearImageId = wearImageId
    },
    setWearImageUrl(wearImageUrl: string) {
      this.wearImageUrl = wearImageUrl
    },
    setRoleCodes(roleCodes: string[]) {
      this.roleCodes = roleCodes
    }
  },
  getters: {
    getAccessToken(): string | undefined {
      return this.sandsTalkToken
    },
    getUsername(): string {
      return this.username
    },
    getPassword(): string {
      return this.password
    },
    getAuthToken(): string {
      return this.password
    },
    getUserMobile(): string {
      return this.password
    },
    getBusinessWechatCode(): string {
      return this.wxworkCode
    },
    getBusinessWechatType(): string {
      return this.wxworkType
    },
    getAppId(): string {
      return this.appId
    },
    getJumpName(): string {
      return this.jumpName
    },
    getJumpType(): string {
      return this.wxworkJumpType
    },
    getJumpModuleId(): string {
      return this.wxworkJumpModuleId
    },
    getCustomTemplateId(): string {
      return this.customTemplateId
    },
    getTeamStudy(): number {
      return this.teamStudy
    },
    getUserAuth(): { teamLearningLabel: number; teachingMgtLabel: number; workbenchLabel: number } {
      return this.userAuth
    },
    getTeachingMgtLabel(): number {
      return this.teachingMgtLabel
    },
    getShowCompany(): boolean {
      return this.showCompany
    },
    getDeptId(): string {
      return this.deptId
    },
    getHasHistoryData(): boolean {
      return this.hasHistoryData
    },
    getRoleCodes(): string[] {
      return this.roleCodes
    }
  },
  persist: true
})
